import React from 'react';
import Title from '../../components/Title/Title';
import styles  from "./ChooseItem.module.sass";

const ChooseItem = React.forwardRef((props, ref) => {
        return (
            <div ref={ref} className={[styles.chooseItems, props.className].join(' ')}>
                 <Title title={props.title} />

                <div className={styles.listButtons}>
                    {props.children}
                </div>
            </div>
        )
});

export default ChooseItem;
